package game.entity

import game.Game
import game.Room

class HeartContainer: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("heart-container")
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.player.maxLife++
        game.player.heal()
        game.playSound("heart")
        room.removePermanently(game, this)

        return true
    }
}